import { BffWorkingHours } from '@/types/generated';

const parseTime = (time: string) => {
	const [hour, minute] = time.slice(0, -2).split(':');
	const isPM = time.slice(-2).toLowerCase() === 'pm';
	let hours = Number.parseInt(hour, 10);
	if (isPM && hours < 12) {
		hours += 12;
	}
	if (!isPM && hours === 12) {
		hours = 0;
	}
	return hours * 60 + Number.parseInt(minute || '0', 10);
};

export const isOfficeClosed = (workingHours: BffWorkingHours[]) => {
	const today = new Date();
	const dayOfWeek = today.toLocaleString('en-US', { weekday: 'long' });
	const todaysHours = workingHours.find((d) => d.date === dayOfWeek);

	if (!todaysHours?.open?.from || !todaysHours?.open?.to) {
		return true;
	}

	const openTime = parseTime(todaysHours.open.from);
	const closeTime = parseTime(todaysHours.open.to);
	const currentTime = today.getHours() * 60 + today.getMinutes();

	return currentTime < openTime || currentTime >= closeTime;
};
